import DefaultCRUD from '../utils'
const resource = `/opora`;

const { get, create } = DefaultCRUD(resource)

export default {
  get,
  create,
}
